import { isUserComingFromSerp } from '../../ts/service/referrer-service.ts';
import { loadSubscriptionModal } from '../../ts/component/modal/subscriptionProposal/index.ts';
import { openTab } from '../../ts/utils/open-tab.ts';
import { createCookie, readCookie, eraseCookie } from '../../ts/utils/cookie.ts';
import { EventConstants, once } from '../../ts/service/event-service.ts';

angular
  .module('jrJobPreview', ['jrConfig'])
  .value('isUserComingFromSerpMethod', isUserComingFromSerp)
  .value('loadSubscriptionModal', loadSubscriptionModal)
  .value('openTab', openTab)
  .value('createCookie', createCookie)
  .value('readCookie', readCookie)
  .value('eraseCookie', eraseCookie)
  .controller('JobPreviewCtrl', JobPreviewCtrl);

JobPreviewCtrl.$inject = [
  '$scope',
  '$filter',
  'SearchConfig',
  'Messages',
  'isUserComingFromSerpMethod',
  'loadSubscriptionModal',
  'openTab',
  'createCookie',
  'readCookie',
  'eraseCookie',
];

function JobPreviewCtrl(
  $scope,
  $filter,
  SearchConfig,
  Messages,
  isUserComingFromSerpMethod,
  loadSubscriptionModal,
  openTab,
  createCookie,
  readCookie,
  eraseCookie
) {
  const isUserComingFromSerp = isUserComingFromSerpMethod(window.location.href);
  const {
    isMobile = false,
    canShowSubscriptionPopup = false,
    feature: {
      newCtaEnabled = false,
      subPopupClickingOnShowMoreButtonEnabled = false,
      subPopupClickingOnApplyButtonEnabled = false,
    } = {},
    jobPreviewPage: { organicAdvertType = false, advertApplyURL = '', backlinkUrl = '' } = {},
  } = jrConfigGlobal;

  $scope.toggleFullTextAction = subPopupClickingOnShowMoreButtonEnabled
    ? loadSubscriptionPopupOnShowMoreBtn
    : toggleFullTextAction;
  $scope.showMoreLessButton = false;
  $scope.searchUrl = window.location.search;
  $scope.referrer = document.referrer;
  $scope.displayShowMoreButton = jrConfigGlobal.feature.descriptionFullModeEnabled;
  $scope.backLinkUrl = isUserComingFromSerp
    ? document.referrer
    : jrConfigGlobal.jobPreviewPage.backlinkUrl;
  $scope.backlinkLabel = getBacklinkLabel(isUserComingFromSerp);

  $scope.upButtonClass = newCtaEnabled
    ? getUpButtonClass(isMobile, organicAdvertType)
    : 'js-jpp-apply-button';

  $scope.downButtonClass = newCtaEnabled
    ? getDownButtonClass(isMobile, organicAdvertType)
    : 'js-jpp-other-jobs-button jr-button--ghost';

  $scope.upButtonMessage = newCtaEnabled
    ? getUpButtonMessage(isMobile, organicAdvertType)
    : Messages.JobPreviewViewSiteButton;

  $scope.downButtonMessage = newCtaEnabled
    ? getDownButtonMessage(isMobile, organicAdvertType)
    : Messages.JobPreviewOtherJobsBtn;

  $scope.upButtonLink = newCtaEnabled
    ? getUpButtonLink(isMobile, organicAdvertType)
    : advertApplyURL;

  $scope.downButtonLink = newCtaEnabled
    ? getDownButtonLink(isMobile, organicAdvertType)
    : backlinkUrl;

  $scope.backLinkCss = newCtaEnabled ? 'jpp-backlink__new-cta-enabled' : undefined;

  $scope.canShowSubscriptionPopup = canShowSubscriptionPopup;
  $scope.canShowSubscriptionPopupClickingOnApplyBtn =
    $scope.canShowSubscriptionPopup && subPopupClickingOnApplyButtonEnabled;
  $scope.applyUrlTarget = '';

  const jobPreviewDescription = document.getElementsByClassName('js-jpp-advert-description')[0];

  $scope.showMoreLessButtonVisible = function () {
    if (jobPreviewDescription.scrollHeight > jobPreviewDescription.offsetHeight) {
      $scope.showMoreLessButton = true;
    }
  };

  if (subPopupClickingOnShowMoreButtonEnabled && !$scope.canShowSubscriptionPopup) {
    const cookieValue = readCookie('sub_from_showmore_btn');
    if (cookieValue) {
      eraseCookie('sub_from_showmore_btn');
      toggleFullTextAction();
    }
  }
  once(EventConstants.subscriptionSentWhenApplyShowMoreFlowIsEnabled, (event) => {
    $scope.canShowSubscriptionPopup = false;
    if (event.detail.source === 'jppApplyBtn') {
      if (event.detail.shouldReload && $scope.applyUrlTarget === '_blank') {
        openTab(advertApplyURL, $scope.applyUrlTarget);
        setTimeout(() => {
          window.location.reload();
        });

        return;
      }
      openTab(advertApplyURL, $scope.applyUrlTarget);
    } else if (event.detail.source === 'jppShowMoreBtn') {
      if (event.detail.shouldReload) {
        createCookie('sub_from_showmore_btn', 1, { days: 0.05 });
        setTimeout(() => {
          window.location.reload();
        });

        return;
      }
      toggleFullTextAction();
    }
    $scope.$digest();
  });

  $scope.loadSubscriptionPopupOnApplyBtn = function (e) {
    e.preventDefault();
    if (e.target.href !== advertApplyURL) {
      openTab(e.target.href, e.target.target);

      return;
    }

    if ($scope.canShowSubscriptionPopupClickingOnApplyBtn) {
      $scope.applyUrlTarget = e.target.target;
      loadSubscriptionModal('jppApplyBtn');

      return;
    }

    openTab(e.target.href, e.target.target, true);
  };

  function loadSubscriptionPopupOnShowMoreBtn() {
    if ($scope.canShowSubscriptionPopup) {
      loadSubscriptionModal('jppShowMoreBtn');

      return;
    }
    toggleFullTextAction();
  }

  function toggleFullTextAction() {
    $scope.toggleFullText = !$scope.toggleFullText;
    if (!$scope.toggleFullText) {
      jobPreviewDescription.scrollTop = 0;
    }
  }

  function getBacklinkLabel(isUserComingFromSerp) {
    const what = isUserComingFromSerp ? SearchConfig.what : SearchConfig.computedWhat;
    const where = isUserComingFromSerp ? SearchConfig.where : SearchConfig.computedWhere;

    return what && where ? `${what} / ${where}` : what || where;
  }

  function getUpButtonClass(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType
      ? 'js-jpp-apply-button jr-button--ghost'
      : 'js-jpp-other-jobs-button';
  }

  function getDownButtonClass(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType
      ? 'js-jpp-other-jobs-button'
      : 'js-jpp-apply-button jr-button--ghost';
  }

  function getUpButtonMessage(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType
      ? Messages.JobPreviewViewSiteButton
      : Messages.JobPreviewOtherJobsBtn;
  }

  function getDownButtonMessage(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType
      ? Messages.JobPreviewOtherJobsBtn
      : Messages.JobPreviewViewSiteButton;
  }

  function getUpButtonLink(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType ? advertApplyURL : backlinkUrl;
  }

  function getDownButtonLink(isMobile, organicAdvertType) {
    return isMobile && !organicAdvertType ? backlinkUrl : advertApplyURL;
  }
}
